<template>
  <div class="hay-loading-mask">
    <div class="hay-loading-spinner">
      <i class="hay-icon-loading"></i>
      <p class="hay-loading-text">{{ title }}</p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'

export default defineComponent({
  name: 'HayLoading',
  setup() {
    const title = ref('')
    const setTitle = (newTitle: string) => {
      title.value = newTitle
    }

    return { title, setTitle }
  }
})
</script>

<style lang="less" scoped>
.hay-loading-mask {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  background-color: transparent;
  z-index: 9999;
  transition: opacity 0.3s;
  width: 100%;
  height: 100vh;
  .hay-loading-spinner {
    position: absolute;
    width: 100%;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    i {
      display: block;
      width: 30px;
      height: 30px;
      border: 2px solid #666;
      border-top-color: transparent;
      border-radius: 100%;

      animation: circle infinite 0.75s linear;
    }
    .hay-loading-text {
      color: #409eff;
      margin: 3px 0;
      font-size: 14px;
    }
  }
}

.el-icon-loading {
  animation: circle infinite 0.75s linear;
}

// 转转转动画
@keyframes circle {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
